import moment from "moment";
import { Component, createRef } from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { toast } from "react-toastify";

//  Images
import carrentIcon from "include/images/carrent-icon.svg";
import plusIcon from "include/images/plus.svg";

//  Components
import AlertError from "common/alert/alertError";
import DeleteModal from "common/alert/alertModal";
import AlertSuccess from "common/alert/alertSuccess";
import Header from "common/header";
import Loader from "common/loader";
import { deleteSpinPack, deleteSpinPackReceived, getTelegram, loadSpinPack } from "store/telegram";
import SideBar from "../../../common/sidebar";
import AddCoinsPackage from "./addSpinPackage";

class MessageListing extends Component {
  ref = createRef(null);
  state = {
    data: {
      messages: [],
    },
    id: "",
    loadingOptions: false,
    loadingMain: false,
    loadingDelete: false,
    loading: false,
    showDeleteModal: false,
    showAddModal: false,
    deleteId: "",
    editData: null,
    showHistory: false,
    objectId: "",
    object: null,
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      !this.props.getTelegram.spinPackLoading &&
      this.props.getTelegram.spinPackLoading !== prevProps.getTelegram.spinPackLoading
    )
      this.ref.current.complete();

    if (
      this.props.getTelegram.spinPackLoading &&
      this.props.getTelegram.spinPackLoading !== prevProps.getTelegram.spinPackLoading
    )
      this.ref.current.continuousStart();
    if (this.state.showAddModal !== prevState.showAddModal && !this.state.showAddModal) {
      setTimeout(() => {
        this.setState({ editData: null });
      }, 500);
    }
  };
  componentDidMount = () => {
    this.setState({ loadingMain: true });
    this.props.loadSpinPack((res) => {
      this.setState({
        loadingMain: false,
      });
    });
  };

  toggleAddModal = (e) => {
    if (e) e.preventDefault();
    this.setState({ showAddModal: !this.state.showAddModal });
  };
  handleDelete = (e) => {
    this.setState({ loadingDelete: true });
    this.props.deleteSpinPack(this.state.deleteId, (templateRes) => {
      if (templateRes.status == 200) {
        toast(<AlertSuccess message="Deleted!" />, {
          containerId: 1,
        });
        this.props.deleteSpinPackReceived({ _id: this.state.deleteId });
        this.alertModalToggle();
        this.setState({ loadingDelete: false });
      } else {
        toast(<AlertError message={templateRes.data && templateRes.data.message} />, {
          containerId: 1,
        });
        this.alertModalToggle();
        this.setState({ loadingDelete: false });
      }
    });
  };
  alertModalToggle = (e) => {
    if (e) e.preventDefault();
    this.setState({ showDeleteModal: !this.state.showDeleteModal });
  };
  render() {
    const { spinPacks } = this.props.getTelegram;
    return (
      <>
        <Header history={this.props.history} />
        <Loader loaderRef={this.ref} />
        <div className="page-wrapper add-dev-server-wrapper">
          <SideBar page="telegram-mini-app-settings-spin-packs" />

          {!this.state.loadingMain && (
            <div className="main-content-wrapper position-relative">
              <div className="mcw-header d-flex align-items-center">
                <h1>Spin Packs</h1>
                <div className="filter-menu-box d-flex align-items-center ms-auto">
                  <div className="fmb-box">
                    <Link to="#" onClick={this.toggleAddModal} className="btn btn-default btn-sm">
                      <img src={plusIcon} alt="" /> Add a Pack
                    </Link>
                  </div>
                </div>
              </div>
              {spinPacks?.length > 0 && (
                <div className="fwc-wrapper">
                  <div className="fwc-body">
                    <div className="table-responsive">
                      <table className="table large-table">
                        <thead>
                          <tr>
                            <th style={{ width: 75, textAlign: "center" }}>Actions</th>
                            <th>Spins</th>
                            <th>Price</th>
                            <th>Discount</th>
                            <th>Discounted Price</th>
                            <th>Image</th>
                            <th>Created On</th>
                          </tr>
                        </thead>
                        <tbody>
                          {spinPacks
                            ?.toSorted((a, b) => b?.spins - a?.spins)
                            ?.map((packageItem, index) => (
                              <tr>
                                <td>
                                  <Dropdown className=" custom-dropdown">
                                    <Dropdown.Toggle
                                      id="tdDropdownOne"
                                      className="custom-dropdown-toggle"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <img src={carrentIcon} alt="" />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className={`dropdown-menu-start `} aria-labelledby="tdDropdownOne">
                                      <Dropdown.Item
                                        className="dropdown-item"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          this.setState({ editData: packageItem }, () => {
                                            this.toggleAddModal();
                                          });
                                        }}
                                      >
                                        Edit
                                      </Dropdown.Item>{" "}
                                      <Dropdown.Item
                                        className="dropdown-item delete"
                                        onClick={(e) => {
                                          this.setState({ deleteId: packageItem?._id }, () => {
                                            this.alertModalToggle(e);
                                          });
                                        }}
                                      >
                                        Delete
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </td>
                                <td>
                                  <Link
                                    className="two-line-ellipsis"
                                    to={"#"}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.setState({ editData: packageItem }, () => {
                                        this.toggleAddModal();
                                      });
                                    }}
                                  >
                                    {packageItem?.spins}
                                  </Link>
                                </td>{" "}
                                <td>
                                  $
                                  {packageItem?.price?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                                <td>{packageItem?.discount?.toLocaleString("en-us")}%</td>
                                <td>
                                  $
                                  {packageItem?.discountedPrice?.toLocaleString("en-us", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </td>
                                <td>
                                  <div style={{ width: 60 }}>
                                    {packageItem?.image && (
                                      <img src={process.env.REACT_APP_CDN + packageItem?.image} alt="" />
                                    )}
                                  </div>
                                </td>
                                <td>{moment(packageItem.createdAt)?.format("MM/DD/YYYY hh:mm A")}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <AddCoinsPackage
          showModal={this.state.showAddModal}
          toggleModal={this.toggleAddModal}
          loadData={this.props.loadSpinPack}
          edit={this.state.editData}
        />
        <DeleteModal
          alertModalToggle={this.alertModalToggle}
          alertModalShow={this.state.showDeleteModal}
          title="Alert"
          description="Are you sure you want to delete this item?"
          onPress={this.handleDelete}
          loading={this.state.loadingDelete}
        />
        {(this.state.showAddModal || this.state.showHistory) && (
          <div
            className="modal-backdrop show fade"
            onClick={this.state.showHistory ? this.toggleHistoryFlyer : this.toggleAddModal}
          ></div>
        )}
      </>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  loadSpinPack: (callback) => dispatch(loadSpinPack(callback)),
  deleteSpinPack: (id, callback) => dispatch(deleteSpinPack(id, callback)),
  deleteSpinPackReceived: (payLoad) => dispatch(deleteSpinPackReceived(payLoad)),
});
const mapStateToProps = (state) => ({
  getTelegram: getTelegram(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MessageListing));
